import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

import { awayTimeType } from "../../utils/event";

import { CalendarEventBody, CalendarEventTime, CalendarEventTitle } from "./CalendarEvent";

import "./styles.scss";

const AwayTime = ({ details, endTime, label, position, startTime, type }) => {
  const title = label ? label : "Out of Office";

  return (
    <CalendarEventBody
      className="AwayTime__body"
      details={details}
      endTime={endTime}
      position={position}
      startTime={startTime}
    >
      <CalendarEventTitle title={title} />
      <CalendarEventTime endTime={endTime} startTime={startTime} strikeTimes={type?.isCancelled} />
    </CalendarEventBody>
  );
};

AwayTime.propTypes = {
  endTime: PropTypes.instanceOf(moment),
  position: PropTypes.object,
  startTime: PropTypes.instanceOf(moment),
  type: awayTimeType,
};

export { AwayTime };
